module.exports = {
  header: {
    home: 'home',
    about: 'about us',
    products: 'Products and cases',
    solutions: 'solutions',
    partner: 'serve',
    contact: 'contact us',
    button: 'CN'
  },
  slide: {
    title1: 'Customer First',
    title2: 'keep Improving',
    title3: 'Collaboration',
    title4: 'Social Responsibility',
    text1: 'Based on the interests and needs of customers, pursue mutual benefit and win-win',
    text2: 'Virtue and sincerity, fine workmanship and goodness, innovation and far-reaching, hard work and strive for the first',
    text3: 'Efficient operation, tacit cooperation, elite team, unlimited vitality',
    text4: 'Charity to send warmth, love to society, true love forever',
    read_more: 'Read more'
  },
  about: {
    title: 'about us',
    // title_text: 'EachCloud,salesforce partners',
    title_text: 'EachCloud',
    title1: 'National Technological SMEs',
    text1: 'Company network distribution: Chengdu, Shanghai, Shenzhen',
    title2: 'Team Composition',
    text2: 'Founder: Graduated from Top8 in China, technical expert Partner: MBA, 20 years of IT experience in foreign companies',
    title3: 'Mission vision',
    text3: 'Hundreds of millions of enterprises go to the cloud and use technology to empower their development',
    title4: 'Company Culture',
    text4: 'Customer First, Excellence, Teamwork, Social Responsibility',
  },
  products: {
    title: 'Products and Cases',
    title_text: 'Based on the digital needs of modern enterprises, provide highly competitive cloud computing products and services',
    item1: 'Supply Chain Management',
    item1_subTitle: 'A management system of multiple supply chain modes for high-value consumables based on cloud computing and IoT:',
    item1_text: `
        Improved the efficiency of supply chain logistics, information flow and financial flow,
        Intelligent Internet of Things (IoT) reduces workload and reduces errors,
        Integrate with ERP and other original systems to ensure seamless transmission of business information`,
    item2: 'Order system',
    item2_subTitle: `Core business system of China's oil and gas and chemical sector:`,
    item2_text: `
        Single system, multi-function, full-process centralized management, one system to solve all problems,
        Support 800+ concurrent users,
        Fully integrated with China and global company networks, connecting information islands,
        Shorten the statement opening time from one or two weeks to 3-5 days`,
    item3: 'Alumni Platform',
    item3_subTitle: 'WeChat integrated alumni service platform:',
    item3_text: `
        Institutions and alumni manage alumni resumes, career trajectories, and job search intentions on both sides,
        Intelligent job recommendation, support alumni one-click delivery,
        Promote alumni to understand the dynamics of the organization and facilitate the organization of online and offline activities,
        Alumni socialize and promote cross-term and cross-regional alumni exchanges`,
    item4: 'Selection and management system',
    item4_subTitle: 'Future Star Educational Entrepreneurship Project and Maker Selection and Management System:',
    item4_text: `
        Automation of application, initial examination, re-examination and admission process,
        Automatically notify applicants and internal and external interviewers to reduce communication costs,
        Multi-dimensional information management, automatically obtain the latest situation of project financing,
        Gain insight into the entire selection process and provide a visual display of projects and creators`,
    item5: 'Letter management applet',
    item5_subTitle: 'Letter electronic applet and background management system:',
    item5_text: `
        Improve project execution efficiency, enhance project transparency,
        Mini program platform to facilitate communication between teachers and volunteers,
        Volunteers and children are intelligently matched, which greatly improves efficiency
        Public welfare projects to practice corporate social responsibility`,
    item6: 'Print Program',
    item6_subTitle: 'Multi-document batch printing App:',
    item6_text: `
        Self-developed PC-side multi-document batch printing system,
        Add and print local documents in batches,
        Download and print online documents through standardized interfaces`,
    // title:'products',
    // title_text:'Provide various cloud computing application products for enterprises in various industries',
    // sales:'sales',
    // service:'service',
    // platform:'platform',
    // marketing:'marketing',
    // commerce:'commerce',
    // internet:'internet',
    // sales_text:'Give your sales teams the power to close deals like never before with the world’s #1 CRM solution. Increase productivity, keep pipeline filled with solid leads, and score more wins without software, hardware, or speed limits.',
    // service_text:'Enhance your customer support — from call-center software to self-service portals — with more responsive, intuitive, and flexible service solutions that help you anticipate your customers’ needs.',
    // platform_text:'Streamline, automate, and mobilize any business processes anywhere across your business with the Salesforce Platform, your one-stop shop for building apps on the secure and scalable Salesforce technology platform.',
    // marketing_text:'Make the most of every customer interaction by creating personalised, cross-channel customer journeys that deliver exceptional experiences across email, mobile, social, advertising, the web, and more.',
    // commerce_text:'Inspire shoppers with seamless 1-to-1 shopping experiences that unify mobile, social, web, and store with built-in predictive intelligence, mobile-first design, and the agility of the cloud.',
    // internet_text:'Improve every aspect of your customer experience using real-time insights from real behaviour — all by simply connecting your IoT devices, sensors, and products to your Salesforce data.'
  },
  industry: {
    title: 'SERVICE INDUSTRY',
    title_text: 'HELPS YOU FORGE A PATH TO SUCCESS IN YOUR INDUSTRY.',
    ins_title: 'ENTERPRISE BUSINESS SYSTEM DEVELOPMENT AND INTEGRATION',
    automative: 'automative',
    communication: 'Communications',
    financial: 'Financial Services',
    medical: 'Medical Treatment',
    media: 'Media',
    retail: 'Retail',
    education: 'Higher Education',
    manufacturing: 'Manufacturing Industry',
    automative_text: 'Accelerate productivity and drive more customer success.',
    communication_text: 'Communicate on a person-to-person level.',
    financial_text: 'Engage today’s connected clients, and exceed their expectations.',
    medical_text: 'Take patient relationships and medical innovation to new heights.',
    media_text: 'Turn the page on old media models.',
    retail_text: 'Connect every part of your business on a single, intelligent platform.',
    education_text: 'Use social, mobile, and cloud to become a connected campus.',
    manufacturing_text: 'Move beyond the product with personalised service at scale.',

    Salesforce_industy_titie: "CRM, Salesforce Consulting",
    Salesforce_industy1: "You need Customer Relationship Management (CRM)",
    Salesforce_industy1_text1: "CRM is designed to make your customers happy;",
    Salesforce_industy1_text2: "CRM covers all aspects of your communication with customers, and enhances the interaction between you and customers, from sales to marketing to customer service; ",
    Salesforce_industy1_text3: "So as to meet all core requirements for business success.",
    // Salesforce_industy2: "We are Salesforce partners",
    Salesforce_industy2: "Salesforce Consulting",
    Salesforce_industy2_text1: "Salesforce is the world's premier CRM platform;",
    Salesforce_industy2_text2: "Procurement and implementation of sales cloud, service cloud, community cloud and other products;",
    Salesforce_industy3: "PaaS customized development and training",
    Salesforce_industy3_text1: "Customize the system according to your business business, 100% fits the actual business",
    Salesforce_industy3_text2: "You can incorporate your core business system into the platform, and your business can be clouded",
    Salesforce_industy3_text3: "Integrate other systems of the enterprise, unified management and control of data",
    Salesforce_industy3_text4: "Provide administrator and developer training, teach you how to fish",
    Salesforce_industy_des:"Customer Relationship Management (CRM) is designed to manage the most important goal of your business-to make your customers happy. A highly effective customer relationship management system (CRM system) will cover all aspects of communication between you and your customers, and enhance the interaction between you and customers. Sales to marketing to customer service: Let your relationship with existing customers become more stable, and your relationship with new customers will progress faster-to meet all core requirements for business success. Salesforce is the world's premier CRM platform. According to IDC's 2018H1 global market revenue share, Salesforce ranks first in CRM applications.",

    tec_title: 'Technical Advantages',
    heading1: 'PaaS platform',
    heading1_text1: `1、The cloud platform improves development speed, ensures system stability, and reduces IT maintenance costs`,
    heading1_text2: `2、Alibaba Cloud, Microsoft Cloud, Amazon AWS, Salesforce Lightning Platform Development Support`,
    heading1_text3: `3、According to the actual situation of the company, help the company choose the best platform and deliver the corresponding software`,
    heading2: 'Backend Bechnology',
    heading2_text1: `1、Support Java, .NET, Python and other mainstream languages ​​and corresponding frameworks`,
    heading2_text2: `2、Relevant technologies and frameworks can be selected according to the existing IT architecture of the enterprise to ensure the continuity of IT resources`,
    heading2_text3: `3、Enterprise internal and external system integration (data integration, business integration)`,
    heading3: 'Front-end Technology',
    heading3_text1: `1、HTML5 web business platform or website development on computers and mobile phones`,
    heading3_text2: `2、Mini program, PC terminal program, mobile app development`,
    heading3_text3: `3、Support native JS, React, VUE and other front-end frameworks`,
    flow_title: 'Service Process',
    flow_flow1_title: 'Demand Collection',
    flow_flow1_text: 'Work closely with relevant departments to comprehensively explore and sort out hidden needs',
    flow_flow2_title: 'Analysis Design',
    flow_flow2_text: 'Transform requirements into models, architectures and business rules',
    flow_flow3_title: 'Development Test',
    flow_flow3_text: 'Software development, integration defect discovery, debugging and correction',
    flow_flow4_title: 'Online Training',
    flow_flow4_text: 'System installation and migration, multi-dimensional and in-depth user training',
    flow_flow5_title: 'Continuous Optimization',
    flow_flow5_text: 'Support and maintain continuous optimization of all aspects of the system',
    pattern_title: 'Service Model',
    pattern_item1: 'Document Based',
    pattern_item1_text1: 'Traditional IT project model',
    pattern_item1_text2: 'Formulate detailed design and development plans according to requirements',
    pattern_item1_text3: 'Deliver as a whole project',
    pattern_item1_text4: 'The cost of adjusting the demand in the project is high',
    pattern_item1_title: 'Waterfalls flow',
    pattern_item2: 'Based on Communication',
    pattern_item2_text1: 'The latest and leading delivery method',
    pattern_item2_text2: 'Small cycle, big cycle, fast iteration',
    pattern_item2_text3: 'Great efficiency and tolerance for demand changes',
    pattern_item2_text4: 'High-quality project and software delivery',
    pattern_item2_title: 'Agile develop',
  },
  team: {
    title: 'EachCloud Team',
    title_text: 'Our team is active, well-coordinated and energetic',
    person1: 'George, CEO',
    person1_text: 'Confidence in yourself is the first trick of success',
    person2: 'Jack, Founder',
    person2_text: 'Difficulties contain victory, failure breeds success',
    person3: 'James, Arch',
    person3_text: 'The secret of success is never to change your purpose',
    person4: 'Eva, Manager',
    person4_text: 'The secret of success is to seize the moment whenever and wherever possible',
    person5: 'Kanye, TL',
    person5_text: 'Where there is diligence, there is success',
    person6: 'Sandy, SD',
    person6_text: 'there is no royal road to learning diameter, canoes',
    person7: 'Jane, Developer',
    person7_text: 'Patience eis bitter, but its fruit is sweet',
    person8: 'Alex, Developer',
    person8_text: 'Thee best preparation for good work tomorrow is to do good work today',
  },
  contact: {
    title: 'contact us',
    title_text: 'Base in Chengdu, China. Server to Partners Around The Planet',
    address: 'Tianfu New District, Chengdu, China',
    contactinfo: 'Contact Information',
    name: 'Name',
    email: 'Email',
    message: 'Anything',
    send: 'Send to Us',
    received: 'Successed, We will contact you soon!',
    qrcode: 'Follow EachCloud'
  },
  footer: {
    copyright: '© Copyright 2023 EachCloud. All rights reserved.',
    AQ: '蜀ICP备18019677号-1',
    erweima_text: 'Follow WeChat',
    promise_text: 'EachCloud has been concerned about public welfare since its inception. We promise to use 1% of our technology, human resources and resources for social welfare undertakings to help our world become a better place'
  },
  partner: {
    title: 'EachCloud Partners',
    title_text: 'EachCloud attaches great importance to sincere cooperation and mutual benefit.',
    partner1: 'Beijing Lead Foundation',
    partner1_text: 'Let Chinese children, regardless of birth, can enjoy quality education!',
    partner2: 'b-ONE Ortho Corp',
    partner2_text: 'Starting from nothing is the soul of a product, b-ONE is the global high-end orthopedics!',
    partner3: 'Beijing Century TAL Education Technology Co.,Ltd.',
    partner3_text: 'Apply the advanced concept and technology in the world, so that everyone can enjoy quality education!',
    partner4: 'SGS-CSTC Standards Technical Services(Shanghai) Co.,Ltd',
    partner4_text: "The world's leading quality inspection agency. We can provide you with professional business solutions!",
    partner5: 'Shanghai May Foundation',
    partner5_text: "Gather social resorces, and make everyone can participate in public service projects!",
    partner6: 'JiHu GitLab',
    partner6_text: 'JiHu GitLab is The DevOps Platform.',
    partner7: 'GASA University',
    partner7_text: 'Undertaking research, exchange, training, and services related to cutting-edge science for governments and commissions.',
    partner8: 'Corsh',
    partner8_text: 'specializes in the research, development, production, and sales of equipment for solid dosage form mixing, granulation, microsphere preparation, microsphere coating, drying, and material enclosed transportation.'
  },

}



// WEBPACK FOOTER //
// ./src/lang/en.js